import { format } from "date-fns";
import { fromZonedTime } from "date-fns-tz";

export function formatDate(value: string | Date): string {
  return format(value, "yyyy-MM-dd");
}

export function formatDateTime(
  value: string | Date,
  isSecondRequired: boolean = true
): string {
  return format(
    value,
    isSecondRequired ? "yyyy-MM-dd HH:mm:ss" : "yyyy-MM-dd HH:mm"
  );
}

export function formatDateTimeWithoutSeconds(value: string | Date): string {
  return format(value, "yyyy-MM-dd HH:mm");
}

export function formatDateTimeWIthTimezone(value: string | Date): string {
  return format(value, "yyyy-MM-dd'T'HH:mm:ssXXX");
}

export function formatDateTimeWithoutTimezone(value: string | Date): string {
  return format(value, "yyyy-MM-dd'T'HH:mm:ss");
}

export function formatUtcToLocalDateTime(
  value: string | Date,
  isSecondRequired: boolean = true
): string {
  const utcDate = fromZonedTime(value, "UTC");
  return format(
    utcDate,
    isSecondRequired ? "yyyy-MM-dd HH:mm:ss" : "yyyy-MM-dd HH:mm"
  );
}

// Converts a local date time to UTC date time
export function parseDateTimeToUtc(value: string | Date): string {
  return fromZonedTime(value, "UTC").toISOString();
}

export function formatTimestampToLocalDateTime(
  timestamp: string,
  isSecondRequired: boolean = true
): string {
  const newDate = new Date(Number(timestamp) * 1000);
  return format(
    newDate,
    isSecondRequired ? "yyyy-MM-dd HH:mm:ss" : "yyyy-MM-dd HH:mm"
  );
}